import { render, staticRenderFns } from "./ShippingPlans.vue?vue&type=template&id=1a63ca64&scoped=true&"
import script from "./ShippingPlans.vue?vue&type=script&lang=js&"
export * from "./ShippingPlans.vue?vue&type=script&lang=js&"
import style0 from "./ShippingPlans.vue?vue&type=style&index=0&id=1a63ca64&prod&lang=css&"
import style1 from "./ShippingPlans.css?vue&type=style&index=1&prod&lang=css&"
import style2 from "./ShippingPlans.vue?vue&type=style&index=2&id=1a63ca64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a63ca64",
  null
  
)

export default component.exports